import APIHelper from "@giscon/utils.api-helper-esri";
import React from "react";

class PrintArea extends React.Component {
  constructor(props) {
    super(props);
    this.map = props.map;
    this.mapView = props.mapView;
    this.layer = APIHelper.createGraphicsLayer();
    this.layer.opacity = 0.5;
    this.layer.name = "PrintAreaLayer"; // TODO: API dependant?
    this.onChangeExtent = props.onChangeExtent;
    this.drawPrintArea();
  }

  componentDidMount = () => {
    APIHelper.addToMap(this.map, this.layer, this.mapView);
    this.zoomHandler = APIHelper.addOnZoomEndListener(
      this.map,
      this.drawPrintArea,
      this.mapView
    );
    this.panHandler = APIHelper.addOnPanEndListener(
      this.map,
      this.drawPrintArea,
      this.mapView
    );
  };

  componentWillUnmount = () => {
    if (this.zoomHandler) {
      this.zoomHandler.remove();
    }
    if (this.panHandler) {
      this.panHandler.remove();
    }
    if (this.map && this.layer) {
      APIHelper.removeFromMap(this.map, this.layer, this.mapView);
    }
  };

  calculatePrintArea = (mapScale, mapTemplate) => {
    if (
      mapScale.value !== null &&
      mapScale.value !== undefined &&
      mapScale.value !== "0.0" &&
      mapTemplate !== null &&
      mapTemplate !== undefined &&
      mapTemplate.width !== null &&
      mapTemplate.width !== undefined &&
      mapTemplate.width !== 0 &&
      mapTemplate.height !== null &&
      mapTemplate.height !== undefined &&
      mapTemplate.height !== 0
    ) {
      const scale = parseFloat(mapScale.value);
      const templateWidth = mapTemplate.width;
      const templateHeight = mapTemplate.height;
      const extentPoints = this.getPrintRectangleCoords(
        scale,
        templateWidth,
        templateHeight
      );
      this.printArea = APIHelper.createExtent(
        extentPoints[0].x,
        extentPoints[0].y,
        extentPoints[1].x,
        extentPoints[1].y,
        this.mapView.spatialReference
      );
      this.onChangeExtent(this.printArea);
    } else {
      this.onChangeExtent(null);
      this.printArea = null;
    }
  };

  drawPrintArea = (mapScale, mapTemplate) => {
    APIHelper.clearLayer(this.layer);
    if (!mapScale || !mapScale.value) {
      mapScale = this.props.mapScale;
    }
    if (!mapTemplate || !mapTemplate.value) {
      mapTemplate = this.props.mapTemplate;
    }
    this.calculatePrintArea(mapScale, mapTemplate);
    if (this.printArea) {
      const OPTuch = APIHelper.differenceOfGeometries(
        APIHelper.createExtent(
          this.mapView.extent.xmin - this.mapView.extent.width,
          this.mapView.extent.ymin - this.mapView.extent.height,
          this.mapView.extent.xmax + this.mapView.extent.width,
          this.mapView.extent.ymax + this.mapView.extent.height,
          this.mapView.spatialReference
        ),
        this.printArea
      );
      const graphic = APIHelper.createGraphic(
        OPTuch,
        {
          type: "esriSFS",
          style: "esriSFSSolid",
          color: [30, 30, 30, 100],
          outline: {
            type: "esriSLS",
            style: "esriSLSNull",
            color: [110, 110, 110, 255],
            width: 1
          }
        },
        {}
      );
      APIHelper.addGraphicToLayer(graphic, this.layer);
    }
  };

  getPrintRectangleCoords(scale, templateWidth, templateHeight) {
    const displayCoords = this.calculatePageBoundsPixels(
      scale,
      templateWidth,
      templateHeight
    ).map(function (i) {
      return i / devicePixelRatio;
    });
    const bottomLeft = APIHelper.getMapPoint(
      displayCoords[0],
      displayCoords[3],
      this.map,
      this.mapView
    );
    const topRight = APIHelper.getMapPoint(
      displayCoords[2],
      displayCoords[1],
      this.map,
      this.mapView
    );
    return [bottomLeft, topRight];
  }

  onOpen = () => {
    APIHelper.showLayer(this.layer);
  };

  onClose = () => {
    APIHelper.hideLayer(this.layer);
  };

  calculatePageBoundsPixels(scale, templateWidth, templateHeight) {
    let resolution;
    if (this.mapView) {
      resolution = this.mapView.extent.width / this.mapView.width;
    } else {
      resolution = this.map.extent.getWidth() / this.map.width;
    }
    const w =
      (((templateWidth / 1000.0) * scale) / resolution) * devicePixelRatio;
    const h =
      (((templateHeight / 1000.0) * scale) / resolution) * devicePixelRatio;
    let center;
    if (this.mapView) {
      center = [
        (this.mapView.width * devicePixelRatio) / 2,
        (this.mapView.height * devicePixelRatio) / 2
      ];
    } else {
      center = [
        (this.map.width * devicePixelRatio) / 2,
        (this.map.height * devicePixelRatio) / 2
      ];
    }
    const minx = center[0] - w / 2;
    const miny = center[1] - h / 2;
    const maxx = center[0] + w / 2;
    const maxy = center[1] + h / 2;
    return [minx, miny, maxx, maxy];
  }

  render() {
    return null;
  }
}

export default PrintArea;
